import { Item } from "app/models/item.inferface";

export class UserItemsFakeDb {
    public static UsersItems: Item[] = [
        {
            id: 1,
            description: 'Matías Fontenla'
        },
        {
            id: 2,
            description: 'User 2'
        },
        {
            id: 3,
            description: 'User 3'
        },
    ]
}
